<div class="modal-container">
  <div class="modal-header">
    <h3 class="px-1 pt-2">
      {{ "accountRegistration.confirm_address.title" | cxTranslate }}
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <img
        alt=""
        width="20"
        height="20"
        src="/icons/{{ baseSiteId }}/close.svg"
        />
    </button>
  </div>

  <div class="modal-body">
    <p>
      {{ "accountRegistration.confirm_address.address_not_match" | cxTranslate }}
    </p>

    <mat-dialog-content>
      <!-- typed address -->
      <h4 class="my-4">
        {{ "accountRegistration.confirm_address.address_entered" | cxTranslate }}
      </h4>
      <label
        class="address-option typed"
        (click)="selectAddress('typed')"
        >
        <input
          type="radio"
          name="address"
          [checked]="selected === 'typed'"
          />
        <span>{{ typed }}</span>
      </label>

      <h4 class="my-4">
        {{ "accountRegistration.confirm_address.address_suggestion" | cxTranslate }}
      </h4>

      <div class="suggestions">
        @if (resolvedSuggestions.length === 0) {
          <p>
            Loading suggestions...
          </p>
        }

        @for (s of resolvedSuggestions; track s) {
          <label
            class="address-option suggested"
            (click)="selectAddress(s.placeId)"
            >
            <input
              type="radio"
              name="address"
              [checked]="selected === s.placeId"
              />
            <span>{{ s.display }}</span>
          </label>
        }
      </div>
    </mat-dialog-content>
  </div>

  <mat-dialog-actions class="invoice-btngrps">
    <button class="btn-secondary" mat-button (click)="cancel()">
      Cancel
    </button>
    <button class="btn-primary" mat-raised-button (click)="confirm()">
      Confirm
    </button>
  </mat-dialog-actions>
</div>
